module.exports = __webpack_public_path__ + "img/logo-white.0ba4ab05.png";